<template lang="pug">
    paginate(
        :value="currentPage"
        :page-count="totalPages"
        :page-range="5"
        :margin-pages="1"
        :click-handler="onClickPage"
        :first-last-button="true"
        first-button-text="«"
        last-button-text="»"
        prev-text="‹"
        next-text="›"
        container-class="pager"
        page-class="pager-item"
        page-link-class="pager-link"
        prev-class="pager-item"
        prev-link-class="pager-link"
        next-class="pager-item"
        next-link-class="pager-link"
        break-view-class="pager-item"
        break-view-link-class="pager-link"
        active-class="pager-active"
        disabled-class="pager-disabled"
    )
</template>

<script>
import Paginate from 'vuejs-paginate';

export default {
    name: "pagination",
    components: {
        paginate: Paginate,
    },
    props: {
        totalPages: {
            type: Number,
            required: true,
        },
        perPage: {
            type: Number,
            required: true,
        },
        currentPage: {
            type: Number,
            required: true,
        },
    },
    methods: {
        onClickPage(page) {
            this.$emit('pagechanged', page);
        },
    },
}
</script>

<style lang="scss">
.pager {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    margin: 25px 0 0;
    padding: 0;
    list-style: none;
}

.pager-link {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 36px;
    height: 36px;
    padding: 0 10px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    background: #fff;
    color: #374151;
    font-size: 14px;
    line-height: 1;
    text-decoration: none;
}

.pager-item:not(.pager-disabled):not(.pager-active) .pager-link:hover {
    border-color: #2563eb;
    color: #2563eb;
}

.pager-active .pager-link {
    background: #2563eb;
    border-color: #2563eb;
    color: #fff;
}

.pager-disabled .pager-link {
    color: #9ca3af;
    background: #f9fafb;
    pointer-events: none;
}
</style>
